export enum ConversationType {
    None = 0,
    Booking = 1,
    Subscription = 2,
    Advert = 3,
    PinboardMessage = 4,
    Normal = 5,
}